import { render, staticRenderFns } from "./_MenuItem.vue?vue&type=template&id=64aa900e&"
import script from "./_MenuItem.vue?vue&type=script&lang=ts&"
export * from "./_MenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64aa900e')) {
      api.createRecord('64aa900e', component.options)
    } else {
      api.reload('64aa900e', component.options)
    }
    module.hot.accept("./_MenuItem.vue?vue&type=template&id=64aa900e&", function () {
      api.rerender('64aa900e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/navbar/_MenuItem.vue"
export default component.exports